import FilterMenu from "./filtermenu.js";
import FilterValues from "./filtervalues.js";
import UpdateFilterUrl from "./updatefilterurl.js";
import SelectedFilters from "./selectedfilters.js";
import { prodListValues } from './shared.js';

const timerInterval = 500;
const productionTime = document.getElementById('productionTimeContent');
const imprintLocationCount = document.getElementById('imprintLocationCountContent');
const imprintColorCount = document.getElementById('imprintColorCountContent');
const mobileFilterDropDown = document.getElementById('filterDropDown');
var productionTimer;
var locationTimer;
var colorTimer;

class RadioButtonFilter {
    events() {
        productionTime && Array.prototype.forEach.call(productionTime.querySelectorAll('input[type=radio]'), (el) => {
            el.addEventListener('change', () => {
                clearTimeout(productionTimer);
                productionTimer = setTimeout(() => this.action(el), timerInterval);
            });
        });

        imprintLocationCount && Array.prototype.forEach.call(imprintLocationCount.querySelectorAll('input[type=radio]'), (el) => {
            el.addEventListener('change', () => {
                clearTimeout(locationTimer);
                locationTimer = setTimeout(() => this.action(el), timerInterval);
            });
        });

        imprintColorCount && Array.prototype.forEach.call(imprintColorCount.querySelectorAll('input[type=radio]'), (el) => {
            el.addEventListener('change', () => {
                clearTimeout(colorTimer);
                colorTimer = setTimeout(() => this.action(el), timerInterval);
            });
        });
    };

    action(element) {
        // clear out any existing filters previously selected
        const id = element.id.slice(0, element.id.lastIndexOf('_') + 1);
        Array.prototype.forEach.call(SelectedFilters.selectedFilterList.querySelectorAll('div[class*="' + id + '"]'), function (el) {
            var index = el.classList.value.indexOf(id) + id.length;
            FilterMenu.markUnSelected(document.getElementById(id + el.classList.value.slice(index).split(/\s/)[0]));
        });

        FilterMenu.markSelected(element);

        if (mobileFilterDropDown.classList.contains('active')) {
            mobileFilterDropDown.click();
        }

        UpdateFilterUrl.update(FilterValues, prodListValues, false);
    };
}

export default new RadioButtonFilter();